<template>
  <div class="d-flex">
    <navigator :flag="navFlag" />
    <OnboardingWrapper class="dashboard-wrapper">
      <div class="dashboard-page">
        <!-- Header -->
        <div class="title-header">
          <h1 v-if="userType == 1">Dashboard</h1>
          <h1 v-else-if="userType == 2">Projects</h1>
        </div>

        <!-- Main Content -->
        <div class="top-sections">
          <!-- Left: My Projects -->
          <div class="p-1">
            <div class="p-headers" id="assignments-section">
              My Projects
              <b-button
                v-if="userType == 1"
                class="new-project-inside"
                v-on:click="addProject()"
              >
                + Create New Playtest
              </b-button>
            </div>

            <div
              v-if="filteredProjects.length == 0"
              class="dashboard-no-project"
            >
              <img
                src="../../assets/Not Found.png"
                class="dashboard-no-project-img"
              />
              <div class="dashboard-no-project-txt">No projects found</div>
            </div>

            <div v-else class="assignments-scroll-container">
              <ProjectCardsDev :projects="filteredProjects" />
            </div>
          </div>

          <!-- Right: Messages -->
          <div class="p-2">
            <div class="messages-container">
              <h3 class="p-headers-messages">Messages</h3>
              <div class="messages-scroll">
                <MessageContacts
                  :contacts="contacts"
                  :systemPayloadList="visibleNotifications"
                  @open-chat="openChatPanel"
                  @open-system-popup="openSystemPopup"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Always available chat panel -->
        <MessagePanel ref="messagePanel" :contacts="chatContacts" @system-notification="onSystemNotification" :userType="this.userType"/>
        <SystemNotificationPopup
          v-if="showSystemPopup"
          :notifications="currentNotification"
          @mark-read="markNotificationRead"
          @close="showSystemPopup = false"
        />
      </div>
    </OnboardingWrapper>
  </div>
</template>

<script>
import Chat from '../../Firestore/Chat.js'
import ProjectCardsTester from './ProjectCardsTester.vue'
import ProjectCardsDev from './ProjectCardsDev.vue'
import navigator from '../layout/NavBarNew.vue'
import Loading from '../loading/index.vue'
import GamesObject from '../../Firestore/GamesObject.js'
import GameTesting from '../../Firestore/GameTesting.js'
import MessageContacts from '../messagebox/contactlist.vue'
import MessagePanel from '../messagebox/developer-messagepanel.vue'
import OnboardingWrapper from '../onboarding/OnboardingWrapper.vue'
import SystemNotificationPopup from "../messagebox/SystemNotificationPopup.vue";
import { onboardingService } from '@/services/OnboardingService';
import { initializePageOnboarding } from '@/services/onboardingConfigs';
import { notificationTypes } from "../../util/notificationTypes.js";
import { subscribeTesDevNotifications } from "../../Firestore/NotificationDevTes.js";
import systemNotifications from "../../mixins/systemNotifications.js";

export default {
  name: "Projects",
  mixins: [systemNotifications],
  components: {
    navigator,
    ProjectCardsDev,
    ProjectCardsTester,
    Loading,
    MessageContacts, 
    MessagePanel,
    OnboardingWrapper,
    SystemNotificationPopup
  },
  data() {
    return {
      totalGames: 0,
      isLoading: false,
      navFlag: 0,
      userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1,
      userAvator: require('../../assets/avator_example.jpg'),
      searchTerm: '',
      projects: [],
      allProjects: [],  
      showProfileModal: true,
      viewDetailsPopup: false,
      contacts: [],
      conversations: [],
      isLoadingMessages: false,
      systemNotifications: [],
      showSystemPopup: false,
      currentNotification: null
    }
  },

  computed: {
    filteredProjects: {
      get() {
        return this.projects.filter(proj =>
          proj.gameName.toLowerCase().includes(this.searchTerm.toLowerCase())
        )
      },
      set(projs) {
        return projs
      }
    }
  },

  mounted() { 
    if (window.localStorage.getItem("userType")) {
      this.userType = parseInt(window.localStorage.getItem("userType"));
    } else {
      this.$router.push({ name: 'login' });
      return;
    }

    this.getProjects();
    this.loadUserConversations();

    // Notification Listener
    if (this.userType === 1) {
      const devId = localStorage.getItem("userId");

      this.unsubscribeNotifications = subscribeTesDevNotifications(
        devId,
        this.onSystemNotification,
        (id) => {
          this.systemNotifications = this.systemNotifications.filter(
            n => n.firebaseId !== id
          );
        }
      );
    }


    // Initialize Onboarding
    if (this.userType === 1) {
      this.$nextTick(() => {
        initializePageOnboarding(
          'projects',
          this.userType,
          onboardingService,
          this.$store
        );
      });
    }
  },

  methods: {
    getProjects() {
      this.isLoading = true;
      if (this.userType == 0) {
        GamesObject.getTesterProjects(window.localStorage.getItem('userId'))
          .then(async res => {
            let listOfProjects = [];
            const promises = res.data.map(project => {
              return GameTesting.allPlaytesterSessionsCompleted(project.gameId, window.localStorage.getItem('userId'))
                .then(completed => {
                  if (!completed.data) {
                    listOfProjects.push(project);
                  }
                })
            });
            await Promise.all(promises);
            this.projects = listOfProjects;
            this.filteredProjects = listOfProjects;
            this.isLoading = false;
          })
          .catch(err => {
            console.error(err);
            this.isLoading = false;
          })
      } else if (this.userType == 1) {
        GamesObject.getDevProjects(window.localStorage.getItem('userId'))
          .then(res => {
            this.projects = res.data;
            this.filteredProjects = res.data;
            this.isLoading = false;
          })
          .catch(err => {
            console.error(err);
            this.isLoading = false;
          })
      }
    },

    addProject() {
      this.$router.push({ name: 'addgame' });
    },

    closeModal() {
      this.showProfileModal = false;
    },

    loadUserConversations() {
      this.isLoadingMessages = true;
      const userId = window.localStorage.getItem('userId');

      Chat.getUserConversations(userId, async (result) => {
        if (result.success) {
          this.conversations = result.data.filter(c => c.isAdminChat !== true);
          await this.transformConversationsToContacts();
        } else {
          console.error('Error loading conversations:', result.error);
        }
        this.isLoadingMessages = false;
      }).catch(err => {
        console.error('Error in getUserConversations:', err);
        this.isLoadingMessages = false;
      });
    },

    formatSystemNotification(noti) {
      const handler = notificationTypes[noti.type];
      if (!handler) return "New notification";
      return handler.getMessage(noti);
    },

    onSystemNotification(data) {
      this.systemNotifications.push({
        ...data,
        id: data.firebaseId,
        unread: data.unread,
        timestamp: data.timestamp && data.timestamp.toDate
          ? data.timestamp.toDate()
          : new Date(data.timestamp),
      });
      this.transformConversationsToContacts();
    },

    formatTime(ts) {
      if (!ts) return '';
      const date = new Date(ts);
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    },

    async transformConversationsToContacts() {
      const currentUserId = window.localStorage.getItem("userId");
      const contactsArray = [];
      const visible = this.visibleNotifications;
      const unread = visible.length;

      if (visible.length > 0) {
        const lastNoti = visible[0];
        contactsArray.push({
          id: "__system_notification__",
          type: "system",
          name: "Notifications",
          avatar: require("@/assets/notif_icon.png"),
          lastMessage: this.formatSystemNotification(lastNoti),
          lastMessageAt: new Date(9999999999999),
          unreadCount: unread
        });
      }

      for (const conversation of this.conversations) {
        try {
          const otherUserId = conversation.participants.find(id => id !== currentUserId);
          if (!otherUserId) continue;
          const userResult = await Chat.getUserInfo(otherUserId);
          if (userResult.success) {
            const userData = userResult.data;
            contactsArray.push({
              id: otherUserId,
              conversationId: conversation.conversationId,
              type: "user",
              name: userData.nickName || userData.userName || "Unknown User",
              avatar: userData.img || require("../../assets/avator_example.jpg"),
              lastMessage: conversation.lastMessage || "No messages yet",
              lastMessageAt: conversation.lastMessageAt,
              unreadCount: (conversation.unreadCount && conversation.unreadCount[currentUserId]) || 0,
              messages: [], // MessagePanel
              acceptedStatus: conversation.acceptedStatus
            });
          }
        } catch (err) {
          console.error("Error transforming conversation:", err);
        }
      }

      contactsArray.sort((a, b) => {
        const getTime = ts => {
          if (!ts) return 0;
          if (ts.toDate) return ts.toDate().getTime();
          if (ts instanceof Date) return ts.getTime();
          return 0;
        };
        return getTime(b.lastMessageAt) - getTime(a.lastMessageAt);
      });

      this.contacts = contactsArray;
    },

    openChatPanel(contact) {
      const fullContact = this.contacts.find(c => c.id === contact.id);
      if (!fullContact) {
        console.error('Contact not found for opening chat:', contact.id);
        return;
      }
      if (this.$refs.messagePanel && this.$refs.messagePanel.openPanel) {
        this.$refs.messagePanel.openPanel(fullContact);
      } else {
        console.error('MessagePanel ref not found or openPanel missing');
      }
    }
  }
}
</script>

<style scoped>
.title-header {
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;
  width: 100%;
  box-shadow: 0 4px 10px -6px grey;
}

.title-header h1, .title-header h3 {
  color: #FF7222;
  font-weight: bold;
}

.new-project-inside {
  position: absolute;
  top: 18px;
  right: 40px;
  background: #ff7222 !important;
  border: none !important;
  color: white !important;
  border-radius: 10px;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 0.7rem 1.5rem;
  height: 2.8rem;
  line-height: 1.4rem;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease-in-out;
  z-index: 5;
}

.new-project-inside:hover {
  background: #e55a0f !important;
  transform: translateY(-2px);
}

.p-1 {
  position: relative;
  opacity: 1;
  padding-bottom: 60px;
}

.dashboard-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  max-width: 100vw;
  background-color: #EEEEEE;
  overflow-x: hidden;
}

.dashboard-no-project {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40vh;
  margin-top: 2rem;
}

.dashboard-no-project-img {
  width: 8%;
  max-width: 120px;
}

.dashboard-no-project-txt {
  font-size: 16px;
  line-height: 15px;
  color: #C4C2C2;
  margin-top: 1rem;
}

.top-sections {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: stretch;
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.p-1, .p-2 {
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 30px;
  flex: 1;
  margin: 0 10px;
  min-width: 0;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.p-1 { max-width: 70%; overflow-y: auto; }
.p-2 { max-width: 30%; overflow-y: hidden; }

.p-3 {
  width: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 30px;
  margin: 20px 30px 20px 30px;
  box-sizing: border-box;
}

.assignments-scroll-container {
  overflow-x: auto;
  overflow-y: auto;
  white-space: normal;
  padding-bottom: 10px;
  max-height: 500px;
  scrollbar-width: thin;
  scrollbar-color: #FF7222 #f1f1f1;
}

.assignments-scroll-container::-webkit-scrollbar {
  height: 8px;
}
.assignments-scroll-container::-webkit-scrollbar-thumb {
  background: #FF7222;
  border-radius: 4px;
}
.assignments-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #e55a0f;
}

.p-headers, .p-headers-messages {
  text-align: left;
  font-size: 2.1rem;
  font-weight: bold; 
  color: #FF7222;
  margin-bottom: 25px;
  margin-top: 10px;
  width: 97%;
  border-bottom: 2px solid #FF7222;
  padding-bottom: 10px;
  margin-left: 15px;
  flex-shrink: 0;
}

.messages-container {
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  height: 70vh;
  padding-top: 5px;
}

.messages-scroll {
  flex-grow: 1;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/game-dashboard/Projects.vue